import { useState, useEffect } from "react";
import { t } from "@lingui/core/macro";

/**
 * A component that displays a marker on the map
 *
 * @param {string} props
 * @returns {JSX.Element}
 */
const Marker = (options) => {
  const [marker, setMarker] = useState();
  let contentString = t`Punto di interesse`;
  const infowindow = new window.google.maps.InfoWindow({
    content: contentString,
  });

  /**
   * A function that manages the onclick marker
   * @returns {void} Open an info window
   */
  const onClick = () => {
    infowindow.open({
      anchor: marker,
    });
  };

  /**
   * A function that create a marker with a custom image icon
   * @returns {void} Create a Dom image
   */
  const markerImageCustom = () => {
    // A marker with a custom SVG glyph.
    const glyphImg = document.createElement("img");
    glyphImg.src = options.isOwner ? "/garden_own.png" : "/garden.png";
    return glyphImg;
  };

  // Set a variable of state for a marker
  useEffect(() => {
    if (!marker) {
      setMarker(new window.google.maps.marker.AdvancedMarkerElement());
    } else {
      marker.content = markerImageCustom();
      window.google.maps.event.clearInstanceListeners(marker);
      marker.addListener("click", options.onClick || onClick);
    }
    // eslint-disable-next-line
  }, [options.isOwner]);

  // Set marker properties
  useEffect(() => {
    if (marker) {
      marker.map = options.map;
      marker.position = options.position;
      marker.addListener("click", options.onClick || onClick);
      marker.title = options.title || "";
      marker.content = options.content || markerImageCustom();
      marker.content.classList.add("bounce");
    }
    // Remove marker from map on unmount
    return () => {
      if (marker) {
        marker.setMap(null);
        window.google.maps.event.clearInstanceListeners(marker);
      }
    };
    // eslint-disable-next-line
  }, [marker]);

  return null;
};

export default Marker;
